import { Dispatch, SetStateAction } from 'react'
import { Table, TableContainer } from '@chakra-ui/react'
import {
  AmountUnit,
  DurationUnit,
  FrequencyUnit,
  Method,
  Percentage,
  Regimen,
  SelectedFields,
} from '../../types/Regimen'
import RegimensTableHead from './RegimensTableHead'
import RegimensTableBody from './RegimensTableBody'

interface RegimensTableProps {
  lists: {
    label: string
    fieldId: string
    items: { [itemId: string]: string }
    id: string
  }[]
  records: Regimen[]
  amountEnabled?: boolean
  frequencyEnabled?: boolean
  durationEnabled?: boolean
  methodEnabled?: boolean
  percentageEnabled?: boolean
  allowUpdate?: boolean
  canReactivate?: boolean
  recordLabel: string
  reportingForStart: string
  month: number
  year: number
  setEditingId: Dispatch<SetStateAction<string | undefined>>
  setEditingUsageIndex: Dispatch<SetStateAction<number | undefined>>
  setStartDate: Dispatch<SetStateAction<string>>
  setFrequency: Dispatch<SetStateAction<string>>
  setFrequencyUnit: Dispatch<SetStateAction<FrequencyUnit | undefined>>
  setAmount: Dispatch<SetStateAction<string>>
  setAmountUnit: Dispatch<SetStateAction<AmountUnit | undefined>>
  setMethod: Dispatch<SetStateAction<Method | undefined>>
  setSelectedFields: Dispatch<SetStateAction<SelectedFields>>
  setDuration: Dispatch<SetStateAction<string>>
  setDurationUnit: Dispatch<SetStateAction<DurationUnit | undefined>>
  setPercentage: Dispatch<SetStateAction<Percentage | undefined>>
  modal: { onOpen: () => void }
  setConfirmEndId: Dispatch<SetStateAction<string | undefined>>
  setConfirmDelete: Dispatch<
    SetStateAction<{ recordId: string; usageIndex: number } | undefined>
  >
  onReactivate: (recordId: string) => void
  showCompleted: boolean
}

export default function RegimensTable({
  lists,
  records,
  amountEnabled,
  frequencyEnabled,
  durationEnabled,
  methodEnabled,
  percentageEnabled,
  allowUpdate = true,
  canReactivate = false,
  recordLabel,
  reportingForStart,
  month,
  year,
  setEditingId,
  setEditingUsageIndex,
  setStartDate,
  setFrequency,
  setFrequencyUnit,
  setAmount,
  setAmountUnit,
  setMethod,
  setSelectedFields,
  setDuration,
  setDurationUnit,
  setPercentage,
  modal,
  setConfirmEndId,
  setConfirmDelete,
  onReactivate,
  showCompleted,
}: RegimensTableProps) {
  return (
    <TableContainer>
      <Table size='sm'>
        <RegimensTableHead
          lists={lists}
          amountEnabled={amountEnabled}
          durationEnabled={durationEnabled}
          frequencyEnabled={frequencyEnabled}
          methodEnabled={methodEnabled}
          percentageEnabled={percentageEnabled}
        />
        <RegimensTableBody
          lists={lists}
          records={records}
          amountEnabled={amountEnabled}
          durationEnabled={durationEnabled}
          showCompleted={showCompleted}
          frequencyEnabled={frequencyEnabled}
          methodEnabled={methodEnabled}
          percentageEnabled={percentageEnabled}
          allowUpdate={allowUpdate}
          canReactivate={canReactivate}
          recordLabel={recordLabel}
          reportingForStart={reportingForStart}
          month={month}
          year={year}
          setEditingId={setEditingId}
          setEditingUsageIndex={setEditingUsageIndex}
          setStartDate={setStartDate}
          setFrequency={setFrequency}
          setFrequencyUnit={setFrequencyUnit}
          setAmount={setAmount}
          setAmountUnit={setAmountUnit}
          setMethod={setMethod}
          setSelectedFields={setSelectedFields}
          setDuration={setDuration}
          setDurationUnit={setDurationUnit}
          setPercentage={setPercentage}
          modal={modal}
          setConfirmEndId={setConfirmEndId}
          setConfirmDelete={setConfirmDelete}
          onReactivate={onReactivate}
        />
      </Table>
    </TableContainer>
  )
}
